/**
 * slideDown func
 * @param  {Element} elem Element to show
 * @param  {Int} height Element to show
 */
export function slideDown(el, height) {
  el.style.maxHeight = typeof height === 'undefined' ? '1000px' : height + 'px';
  el.style.opacity = '1';
}
/**
 * slideUp func
 * @param  {Element} elem Element to hide
 */
export function slideUp(el) {
  el.style.maxHeight = '0';
  once(1, function () {
    if (el.style.maxHeight == '0') {
      el.style.opacity = '0';
    }
  });
}

function once(seconds, callback) {
  var counter = 0;
  var time = window.setInterval(function () {
    counter++;
    if (counter >= seconds) {
      callback();
      window.clearInterval(time);
    }
  }, 400);
}
/**
 * fadeOut func
 * @param  {Element} elem Element to hide
 */
export function fadeOut(el) {
  let counter = 0;
  el.style.opacity = 1;
  (function fade() {
    counter++;
    if ((el.style.opacity -= 0.1) < 0 || counter == 11) {
      el.style.display = 'none';
    } else {
      requestAnimationFrame(fade);
    }
  })();
}
/**
 * fadeIn func
 * @param  {Element} elem Element to show
 * @param  {String} display display style
 */
export function fadeIn(el, display) {
  let counter = 0;
  el.style.opacity = 0;
  el.style.display = display || 'block';
  (function fade() {
    counter++;
    var val = parseFloat(el.style.opacity);
    if (!((val += 0.1) > 1 || counter == 11)) {
      el.style.opacity = val;
      requestAnimationFrame(fade);
    }
  })();
}
/**
 * set panel interval loop
 * @param  {Element} el Element to scroll
 * @param  {Number} delay interval delay; default 3000
 */
export function initPanelAutoScroll(el, delay) {
  var intervalDelay = typeof delay === 'undefined' ? 3000 : delay;
  setInterval(function () {
    panelScrollLeft(el);
  }, intervalDelay);
}

/**
 * panel scrollLeft func
 * @param  {Element} el Element to scroll
 */
export function panelScrollLeft(el) {
  if (!document.hidden) {
    if (el.scrollLeft < el.scrollWidth - el.clientWidth) {
      let amount = el.querySelector('.panel').clientWidth + 10; //+ 10px margin
      panelScrollLoop(el, amount);
    } else {
      let amount = -el.scrollWidth;
      panelScrollLoop(el, amount);
    }
  }
}
export function panelScrollLoop(el, amount) {
  let time = 150,
    eAmt = amount / 100,
    curTime = 0,
    scrollCounter = 0,
    start = el.scrollLeft;
  while (curTime <= time) {
    window.setTimeout(panelScroll, curTime, el, scrollCounter, eAmt, start);
    curTime += time / 100;
    scrollCounter++;
  }
}

function panelScroll(el, sc, eAmt, start) {
  el.scrollLeft = eAmt * sc + start;
}

/**
 * scale content body to 100% vw
 * @param  {Element} el Element to scale
 */
export function scaleOnScroll(el) {
  document.addEventListener('scroll', () => {
    let scroll = document.scrollingElement.scrollTop,
      scaleRate = 1000,
      scale = 0.9 + scroll / scaleRate,
      imgScale = 1 - scroll / (scaleRate * 3),
      imgOpacity = 1 - scroll / (scaleRate * 2);
    if (scale <= 1) {
      el.style.transform = 'scale(' + scale + ')';
    } else {
      el.style.transform = 'scale(' + 1 + ')';
    }
    if (imgScale > 0) {
      el.parentNode.parentNode.querySelector('.topGraphic-image').style.transform = 'scale(' + imgScale + ')';
      el.parentNode.parentNode.querySelector('.topGraphic-image').style.opacity = imgOpacity;
    }
  });
}

/**
 * scale main-background to 100% vw
 * @param  {Element} el Element to scale
 */
export function scaleBackgroundImageOnScroll(el) {
  document.addEventListener('scroll', () => {
    let scroll = document.scrollingElement.scrollTop,
      scaleRate = 600,
      imgScale = 1 - scroll / (scaleRate * 3),
      imgOpacity = _CMS_MOBILE ? 1 - scroll / (scaleRate * 0.4) : 1 - scroll / (scaleRate * 2);
    if (imgScale > 0) {
      el.style.transform = 'scale(' + imgScale + ')';
      el.style.opacity = imgOpacity;
    }
  });
}

/**
 * transform translateX to 0% and hide element
 * @param  {Element} el Element to transform
 */
export function progressBarToFull(parent, ms) {
  let progressBar = parent.querySelector('.game-progressbar');
  if (progressBar) {
    const progress = progressBar.querySelector('.game-progressbar-progress');
    const style = window.getComputedStyle(progress);
    const matrix = new DOMMatrixReadOnly(style.transform);
    const prevTranslationX = matrix.m41 || 0;
    if (prevTranslationX == 0) parent.removeChild(progressBar);
    else {
      progress.animate(
        [
          {
            transform: `translateX(${prevTranslationX}px)`
          },
          {
            transform: 'translateY(0)'
          }
        ],
        {
          duration: ms
        }
      );
      setTimeout(() => {
        progressBar = parent.querySelector('.game-progressbar');
        if (progressBar) {
          parent.removeChild(progressBar);
        }
      }, ms);
    }
  }
}
